import { z } from 'zod';
import { requiredUuidString } from '../zod-helpers/index.js';
import { MAX_VENDOR_PARTS_PER_CREATE, MAX_VENDOR_PARTS_PER_CREATE_MESSAGE } from './constraints.js';
import { partCreateVendorPartInputSchema } from './create-input.js';
/**
 * The edit path's counterpart to `createPartInputSchema.vendorParts` — same row schema and same
 * cap, so a cost or vendor id rejected on create cannot be accepted on edit.
 */
export const setPartVendorsInputSchema = z.object({
    partId: requiredUuidString('Part is required.', 'Invalid part selection.'),
    vendors: z
        .array(partCreateVendorPartInputSchema)
        .max(MAX_VENDOR_PARTS_PER_CREATE, MAX_VENDOR_PARTS_PER_CREATE_MESSAGE)
        .superRefine((vendors, ctx) => {
        const seen = new Set();
        for (const [index, vendor] of vendors.entries()) {
            if (seen.has(vendor.vendorId)) {
                ctx.addIssue({
                    code: 'custom',
                    message: 'Each vendor can only appear once.',
                    path: [index, 'vendorId'],
                });
            }
            seen.add(vendor.vendorId);
        }
    }),
});
//# sourceMappingURL=set-vendors-input.js.map